import { Link, useLocation } from "react-router-dom";
import { DESTINATIONS } from "../mock";
import { crumbsFor, HIDE_CRUMBS } from "../content/crumbs";
import { hasBizCrumbs } from "./BizNav";

export const destinationNames = () => Object.fromEntries(DESTINATIONS.map((d) => [d.slug, d.name]));

export function Breadcrumbs() {
  const { pathname } = useLocation();
  if (HIDE_CRUMBS.some((rx) => rx.test(pathname)) || hasBizCrumbs(pathname)) return null;
  const items = crumbsFor(pathname, destinationNames());
  if (items.length < 2) return null;
  return (
    <nav aria-label="Breadcrumb" className="mx-auto max-w-7xl px-4 pt-4 text-xs text-label2 sm:px-6 lg:px-8" data-testid="site-breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map(([label, to], i) => (
          <li key={`${label}-${i}`} className="inline-flex items-center gap-1.5">
            {to ? <Link to={to} className="hover:text-foreground hover:underline" data-testid={`crumb-${i}`}>{label}</Link> : <span className="text-foreground" aria-current="page" data-testid="crumb-current">{label}</span>}
            {i < items.length - 1 && <span aria-hidden="true">/</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
